// SentinelOne Legacy (GUI syntax) datasource mappings.
// Each entry stores the complete prelude string in events[0].
// The emitter returns events[0] directly — no further field/value processing.
// Prelude format: ObjectType = "..." AND EventType = "..."
// Joined with joinDirect since the base renderer finalize() prepends " AND " to its body.
import type { DatasourceMap } from '../datasource.types'

export const s1LegacyMap: DatasourceMap = {
  SentinelOne: {
    any: {
      process_creation: {
        events: ['ObjectType = "process" AND EventType = "Process Creation"'],
      },
      file_event: {
        events: ['ObjectType = "file" AND EventType = "File Creation"'],
      },
      network_connection: {
        events: ['ObjectType = "ip" AND EventType = "IP Connect"'],
        unsupportedFields: ['domain'],
      },
      registry_event: {
        events: [
          'ObjectType = "registry" AND (EventType = "Registry Value Create" OR EventType = "Registry Value Modified" OR EventType = "Registry Key Create")',
        ],
      },
      image_load: {
        events: ['ObjectType = "module" AND EventType = "Module Load"'],
      },
      //authentication_events: {
      //  events: ['ObjectType = "logins" AND EventType = "Login"'],
      //},
      dns: {
        events: ['ObjectType = "dns" AND EventType = "DNS Resolved"'],
      },
      pipe_created: {
        events: ['ObjectType = "named_pipe" AND EventType = "Named Pipe Creation"'],
      },
      //firewall: {
      //  events: ['ObjectType = "ip" AND EventType = "IP Connect"'],
      //},
      //proxy: {
      //  events: ['ObjectType = "url" AND (EventType = "GET" OR EventType = "POST")'],
      //},
    },
  },
}
